import { Modal } from '@mui/material';
import { useState } from 'react';
import { isItUndefined } from '../../util/DataUtil';
import MarketoModalForm from '../marketo-modal-form';
import SkeletonContactUsForm from '../marketo/SkeletonContactUsForm';

const FacilityModal = ({
  children,
  trigger,
  setTrigger,
  global,
  lang,
  marketoId = null,
  partnerName = null,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isDomLoading, setIsDomLoading] = useState(true);

  children = {
    ...children,
    data: {
      trigger,
      setTrigger,
      isSubmitted,
      setIsSubmitted,
    },
    field_marketo_form_ids: [
      { value: isItUndefined(children?.field_marketo_form_ids) },
    ],
    lang,
  };

  const handleClose = () => {
    delete window.MktoForms2;
    setTrigger(false);
  };

  return trigger ? (
    <Modal
      open={trigger}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      {/*<Paper>*/}
      {/*    <Marketo ctaPopUp={true} close={() => setTrigger(false)} global={global}>{children}</Marketo>*/}
      {/*</Paper>*/}
      <div
        className={`paper facility-modal form${marketoId} ${isSubmitted ? 'formSubmitted' : ''}`}
      >
        {/*<Marketo ctaPopUp={true} close={() => setTrigger(false)} global={global}>{children}</Marketo>*/}

        <MarketoModalForm
          lang={lang}
          ctaPopUp={true}
          setIsDomLoading={setIsDomLoading}
          close={handleClose}
          global={children}
          partnerName={partnerName}
        >
          {children}
        </MarketoModalForm>
        {isDomLoading ? <SkeletonContactUsForm /> : null}
      </div>
    </Modal>
  ) : null;
};

export default FacilityModal;
